import { render } from "./opportunity-page-header.vue?vue&type=template&id=5b0e9e00&ts=true"
import script from "./opportunity-page-header.vue?vue&type=script&lang=ts"
export * from "./opportunity-page-header.vue?vue&type=script&lang=ts"

import "./opportunity-page-header.vue?vue&type=style&index=0&id=5b0e9e00&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__